import { useMemo } from 'react';
import { useLiveActivities } from './hooks/liveActivities';
import ActivityTile from './ActivityTile';
import { LiveViewLayout } from './LiveViewLayout';

interface LiveViewProps {
  token: string;
  organisationId: string;
  jobsiteId: string;
}

export default function LiveView({ token, organisationId, jobsiteId }: LiveViewProps) {
  const { isCameraOnline, activities, licensePlates } = useLiveActivities(jobsiteId, token);

  const activitiesSorted = useMemo(() => {
    return Array.from(activities.values()).sort((a, b) => b.captureStartAt.localeCompare(a.captureStartAt));
  }, [activities]);

  const liveViewActivities = useMemo(() => {
    return activitiesSorted.map((activity) => ({
      id: activity.id,
      captureStartAt: activity.captureStartAt,
      renderTile: (isFocus: boolean) => (
        <ActivityTile organisationId={organisationId} jobsiteId={jobsiteId} recording={activity} isFocus={isFocus} />
      ),
    }));
  }, [activitiesSorted, jobsiteId, organisationId]);

  return (
    <LiveViewLayout
      jobsiteId={jobsiteId}
      isCameraOnline={isCameraOnline}
      activities={liveViewActivities}
      overviewRecordings={activitiesSorted}
      licensePlates={licensePlates || {}}
    />
  );
}
